/* esm.sh - bs58@6.0.0 */
import r from"base-x";var a="123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz",o=r(a);export{o as default};
//# sourceMappingURL=bs58.mjs.map